import api from '@/request/api'
import { Dialog, Toast } from 'vant';
import router from '@/router/index'
import Vue from 'vue';
import store from '@/store/index'
import { getLodop } from "./LodopFuncs";
import lodopHelper from './lodopHtmlTemp'

// 点餐详情（废弃）
export function printOrderDetail(data) {
  // console.log('进入了lodop点餐详情', data);
  return new Promise((resolve, reject) => {
    let LODOP = getLodop();
    LODOP.PRINT_INIT(new Date().getTime()); // 初始化
    LODOP.SET_PRINT_STYLE("Alignment", 2);
    LODOP.SET_PRINT_STYLE("FontSize", 15);
    LODOP.ADD_PRINT_TEXT('10mm', '0mm', '48mm', '5mm', data.shopName);
    LODOP.SET_PRINT_STYLE("Alignment", 2);
    LODOP.SET_PRINT_STYLE("FontSize", 10);
    LODOP.ADD_PRINT_TEXT('20mm', '0mm', '48mm', '5mm', '***点菜单***');
    LODOP.SET_PRINT_STYLE("Alignment", 0);
    LODOP.SET_PRINT_STYLE("FontSize", 8);
    if (data.meal_type == 1) {
      LODOP.ADD_PRINT_TEXT('30mm', '0.5mm', '48mm', '5mm', '桌号:' + data.desk_num + '  人数:' + data.people);
    }
    if (data.meal_type == 2) {
      LODOP.ADD_PRINT_TEXT('30mm', '0.5mm', '48mm', '5mm', '流水号:' + data.serial_number);
    }
    LODOP.ADD_PRINT_TEXT('36mm', '0.5mm', '48mm', '5mm', '日期:' + data.date + ' ' + data.time);
    LODOP.ADD_PRINT_TEXT('41mm', '0.5mm', '48mm', '5mm', '订单编号:' + data.orderNum);

    LODOP.ADD_PRINT_LINE("47mm", "0.5mm", "47mm", "56mm", 1, 0.1);

    LODOP.ADD_PRINT_TEXT('50mm', '0.5mm', '10mm', '5mm', '名称');
    LODOP.ADD_PRINT_TEXT('50mm', '24mm', '14.25mm', '5mm', '单价');
    LODOP.ADD_PRINT_TEXT('50mm', '10mm', '14.25mm', '5mm', '数量');
    LODOP.ADD_PRINT_TEXT('50mm', '38mm', '14.25mm', '5mm', '小计');
  
    LODOP.ADD_PRINT_LINE("56mm", "0.5mm", "56mm", "56mm", 1, 0.1);
  
    let iCurLine = 60;//标题行之后的数据从位置80px开始打印
    if (data.printDishList) {
      if (data.printDishList.length > 0) {
        for (let i = 0; i < data.printDishList.length; i++) {
          const element = data.printDishList[i];
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '48mm', '5mm', element[1]);
          iCurLine = iCurLine + 5;
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '7mm', '14.5mm', '5mm', element[4]);
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '21.5mm', '14.5mm', '5mm', element[2].toString());
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '35.5mm', '16mm', '5mm', element[3]);
          iCurLine = iCurLine + 5;
        }
      }
    }

    if (data.addprintDishList) {
      if (data.addprintDishList.length > 0) {
        LODOP.SET_PRINT_STYLE("Alignment", 2);
        LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0mm', '48mm', '5mm', '***加菜***');
        iCurLine = iCurLine + 5;
        LODOP.SET_PRINT_STYLE("Alignment", 0);
        for (let i = 0; i < data.addprintDishList.length; i++) {
          const element = data.addprintDishList[i];
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '48mm', '5mm', element[1]);
          iCurLine = iCurLine + 5;
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '7mm', '14.5mm', '5mm', element[4]);
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '21.5mm', '14.5mm', '5mm', element[2].toString());
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '35.5mm', '16mm', '5mm', element[3]);
          iCurLine = iCurLine + 5;
        }
      }
    }

    LODOP.ADD_PRINT_LINE(iCurLine + 'mm', "0.5mm", iCurLine + 'mm', "56mm", 1, 0.1);
    iCurLine = iCurLine + 1;

    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '19mm', '5mm', '合计');
    if (data.one_dis) {
      if (data.one_dis === 'one_dis') {
        LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '35.5mm', '16mm', '5mm', data.allOriginalPrice.toString());
      } else {
        LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '35.5mm', '16mm', '5mm', data.one_dis.toString());
      }
    } else {
      LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '35.5mm', '16mm', '5mm', '0.00');
    }
    iCurLine = iCurLine + 5;

    LODOP.ADD_PRINT_LINE(iCurLine + 'mm', "0.5mm", iCurLine + 'mm', "48mm", 1, 0.1);
    iCurLine = iCurLine + 1;

    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '48mm', '5mm', '电话：' + data.phone);
    iCurLine = iCurLine + 5;
    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '48mm', '5mm', '地址：' + data.address);
    iCurLine = iCurLine + data.address.length > 10 ? 25 : 15;

    LODOP.ADD_PRINT_LINE(iCurLine + 'mm', "0.5mm", iCurLine + 'mm', "48mm", 1, 0.1);
    iCurLine = iCurLine + 5;
    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '48mm', '5mm', '\n');
    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '48mm', '5mm', '\n');

    iCurLine = iCurLine + 10;
    LODOP.ADD_PRINT_LINE(iCurLine + 'mm', "0.5mm", iCurLine + 'mm', "48mm", 1, 0.1);

    LODOP.SET_PRINT_PAGESIZE(3, 480, '10mm', ''); // 设置纸张大小,方向
    // LODOP.PREVIEW();
    LODOP.PRINT();
    resolve();
  })
}

// 结账单（废弃）
export function printOrderFinish(data) {
  // console.log('进入了lodop结账单', data);
  return new Promise((resolve, reject) => {
    let LODOP = getLodop();
    LODOP.PRINT_INIT(new Date().getTime()); // 初始化
    LODOP.SET_PRINT_STYLE("Alignment", 2);
    LODOP.SET_PRINT_STYLE("FontSize", 15);
    LODOP.ADD_PRINT_TEXT('10mm', '0mm', '48mm', '5mm', data.shopName);
    LODOP.SET_PRINT_STYLE("Alignment", 2);
    LODOP.SET_PRINT_STYLE("FontSize", 10);
    LODOP.ADD_PRINT_TEXT('20mm', '0mm', '48mm', '5mm', '***结账单***');
    LODOP.SET_PRINT_STYLE("Alignment", 0);
    LODOP.SET_PRINT_STYLE("FontSize", 8);
    if (data.meal_type == 1) {
      LODOP.ADD_PRINT_TEXT('30mm', '0.5mm', '48mm', '5mm', '桌号:' + data.num + '  人数:' + data.people);
    }
    if (data.meal_type == 2) {
      LODOP.ADD_PRINT_TEXT('30mm', '0.5mm', '48mm', '5mm', '流水号:' + data.serial_number);
    }
    LODOP.ADD_PRINT_TEXT('36mm', '0.5mm', '48mm', '5mm', '日期:' + data.date + ' ' + data.time);
    LODOP.ADD_PRINT_TEXT('41mm', '0.5mm', '48mm', '5mm', '订单编号:' + data.orderNum);

    LODOP.ADD_PRINT_LINE("47mm", "0.5mm", "48mm", "56mm", 1, 0.1);

    LODOP.ADD_PRINT_TEXT('50mm', '0.5mm', '10mm', '5mm', '名称');
    LODOP.ADD_PRINT_TEXT('50mm', '24mm', '14.25mm', '5mm', '单价');
    LODOP.ADD_PRINT_TEXT('50mm', '10mm', '14.25mm', '5mm', '数量');
    LODOP.ADD_PRINT_TEXT('50mm', '38mm', '14.25mm', '5mm', '小计');
  
    LODOP.ADD_PRINT_LINE("56mm", "0.5mm", "56mm", "56mm", 1, 0.1);
  
    let iCurLine = 60;//标题行之后的数据从位置80px开始打印
    if (data.printDishList) {
      if (data.printDishList.length > 0) {
        for (let i = 0; i < data.printDishList.length; i++) {
          const element = data.printDishList[i];
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '48mm', '5mm', element[1]);
          iCurLine = iCurLine + 5;
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '7mm', '14.5mm', '5mm', element[4]);
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '21.5mm', '14.5mm', '5mm', element[2].toString());
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '35.5mm', '16mm', '5mm', element[3]);
          iCurLine = iCurLine + 5;
        }
      }
    }

    if (data.addprintDishList) {
      if (data.addprintDishList.length > 0) {
        LODOP.SET_PRINT_STYLE("Alignment", 2);
        LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0mm', '48mm', '5mm', '***加菜***');
        iCurLine = iCurLine + 5;
        LODOP.SET_PRINT_STYLE("Alignment", 0);
        for (let i = 0; i < data.addprintDishList.length; i++) {
          const element = data.addprintDishList[i];
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '48mm', '5mm', element[1]);
          iCurLine = iCurLine + 5;
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '7mm', '14.5mm', '5mm', element[4]);
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '21.5mm', '14.5mm', '5mm', element[2].toString());
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '35.5mm', '16mm', '5mm', element[3]);
          iCurLine = iCurLine + 5;
        }
      }
    }

    LODOP.ADD_PRINT_LINE(iCurLine + 'mm', "0.5mm", iCurLine + 'mm', "56mm", 1, 0.1);
    iCurLine = iCurLine + 1;

    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '19mm', '5mm', '原价');
    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '38mm', '19mm', '5mm', data.allOriginalPrice);
    iCurLine = iCurLine + 5;
    if (parseFloat(data.discount_price) > 0) {
      LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '19mm', '5mm', '会员');
      LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '38mm', '19mm', '5mm', '-' + data.discount_price);
      iCurLine = iCurLine + 5;
    }
    if (parseFloat(data.dis_price) > 0) {
      LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '19mm', '5mm', '折扣');
      LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '38mm', '19mm', '5mm', '-' + data.dis_price);
      iCurLine = iCurLine + 5;
    }
    if (parseFloat(data.wipe_price) > 0)  {
      LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '19mm', '5mm', '抹零');
      LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '38mm', '19mm', '5mm', '-' + data.wipe_price);
      iCurLine = iCurLine + 5;
    }
    if (parseFloat(data.return_money) > 0) {
      LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '19mm', '5mm', '退款');
      LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '38mm', '19mm', '5mm', '-' + data.return_money);
      iCurLine = iCurLine + 5;
    }
    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '19mm', '5mm', '实付');
    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '38mm', '19mm', '5mm', data.allFactPrice);
    iCurLine = iCurLine + 5;

    // LODOP.ADD_PRINT_LINE(iCurLine + 'mm', "0.5mm", iCurLine + 'mm', "56mm", 1, 0.1);
    // iCurLine = iCurLine + 1;

    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '48mm', '5mm', '电话：' + data.phone);
    iCurLine = iCurLine + 5;
    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '48mm', '5mm', '地址：' + data.address);
    iCurLine = iCurLine + data.address.length > 10 ? 25 : 15;

    LODOP.ADD_PRINT_LINE(iCurLine + 'mm', "0.5mm", iCurLine + 'mm', "56mm", 1, 0.1);
    iCurLine = iCurLine + 5;
    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '57mm', '5mm', '\n');
    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '57mm', '5mm', '\n');

    iCurLine = iCurLine + 10;
    LODOP.ADD_PRINT_LINE(iCurLine + 'mm', "0.5mm", iCurLine + 'mm', "48mm", 1, 0.1);

    LODOP.SET_PRINT_PAGESIZE(3, 480, '10mm', ''); // 设置纸张大小,方向
    // LODOP.PREVIEW();
    LODOP.PRINT();
    resolve();
  })
}

// 做菜单（废弃）
export function printDish(data) {
  // console.log('进入了lodop前台做菜单', data);
  return new Promise((resolve, reject) => {
    let LODOP = getLodop();
    LODOP.PRINT_INIT(new Date().getTime()); // 初始化
    LODOP.SET_PRINT_STYLE("Alignment", 2);
    LODOP.SET_PRINT_STYLE("FontSize", 15);
    LODOP.ADD_PRINT_TEXT('10mm', '0mm', '57mm', '5mm', '做菜单');
    LODOP.SET_PRINT_STYLE("Alignment", 0);
    LODOP.SET_PRINT_STYLE("FontSize", 8);
    if (data.meal_type == 1) {
      LODOP.ADD_PRINT_TEXT('17mm', '0.5mm', '57mm', '5mm', '桌号:' + data.desk_num);
    }
    if (data.meal_type == 2) {
      LODOP.ADD_PRINT_TEXT('17mm', '0.5mm', '57mm', '5mm', '流水号:' + data.serial_number);
    }
    LODOP.ADD_PRINT_TEXT('23mm', '0.5mm', '57mm', '5mm', '日期:' + data.date + ' ' + data.time);
    LODOP.ADD_PRINT_TEXT('30mm', '0.5mm', '57mm', '5mm', '订单编号:' + data.orderNum);
  
    LODOP.ADD_PRINT_LINE("36mm", "0.5mm", "36mm", "56mm", 1, 0.1);
  
    LODOP.ADD_PRINT_TEXT('40mm', '0.5mm', '34mm', '5mm', '名称');
    LODOP.ADD_PRINT_TEXT('40mm', '37mm', '20mm', '5mm', '数量');
  
    LODOP.ADD_PRINT_LINE("47mm", "0.5mm", "47mm", "56mm", 1, 0.1);
  
    let iCurLine = 50;//标题行之后的数据从位置80px开始打印
    if (data.printDishList) {
      if (data.printDishList.length > 0) {
        LODOP.SET_PRINT_STYLE("FontSize", 12);
        for (let i = 0; i < data.printDishList.length; i++) {
          const element = data.printDishList[i];
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '34mm', '5mm', element[1]);
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '37mm', '20mm', '5mm', element[2].toString());
          let h = 5;
          if (element[1].length > 7) {
            h = 10;
          }
          iCurLine = iCurLine + h;
        }
      }
    }
  
    LODOP.SET_PRINT_STYLE("FontSize", 8);
    LODOP.ADD_PRINT_LINE(iCurLine + 'mm', "0.5mm", iCurLine + 'mm', "56mm", 1, 0.1);
    iCurLine = iCurLine + 1;
  
    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '57mm', '5mm', '电话：' + data.phone);
    iCurLine = iCurLine + 5;
    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '57mm', '5mm', '地址：' + data.address);
    iCurLine = iCurLine + data.phone.length > 10 ? 25 : 15;

    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0mm', '57mm', '5mm', '');
  
    LODOP.SET_PRINT_PAGESIZE(3, 580, 45, ''); // 设置纸张大小,方向
    // LODOP.PREVIEW();
    LODOP.PRINT();
    resolve();
  })
}

// 桌码
export function printDeskCode(data) {
  // console.log('进入了lodop桌码打印', data);
  return new Promise((resolve, reject) => {
    let LODOP = getLodop();
    LODOP.PRINT_INIT(new Date().getTime()); // 初始化
    LODOP.SET_PRINT_STYLE("Alignment", 2);

    LODOP.ADD_PRINT_HTM('10mm', '5mm' , '43.5mm', '43.5mm', `<img style="width: 43.5mm; height: 43.5mm;" src="${data.qrcode}" />`);

    LODOP.SET_PRINT_STYLE("FontSize", 10);
    LODOP.ADD_PRINT_TEXT('55mm', '0mm', '57mm', '5mm', data.n);

    LODOP.SET_PRINT_PAGESIZE(3, 580, 45, ''); // 设置纸张大小,方向
    // LODOP.PREVIEW();
    LODOP.PRINT();
    resolve();
  })
}

// 更新电子秤信息
export function getThisWeightDetail() {
  // window.parent.postMessage({
  //   cmd: 'setToken',
  //   app: 'shouyin',
  // },'*')
  // window.addEventListener('update::weight',function(weight){
  //   console.log(weight);
  //   store.commit('updateWeightDetail', weight);
  // }, false);
  window.addEventListener('message', function (data) {
    // console.log('message------------', JSON.stringify(data));
    if (data.data.weight) {
      store.commit('updateWeightDetail', data.data.weight);
    }
  }, false);
}

// 日报（废弃）
export function printDaily(data) {
  // console.log('进入了lodop日报打印', data);
  return new Promise((resolve, reject) => {
    let LODOP = getLodop();
    LODOP.PRINT_INIT(new Date().getTime()); // 初始化
    LODOP.SET_PRINT_STYLE("Alignment", 2);
    LODOP.SET_PRINT_STYLE("FontSize", 15);
    LODOP.ADD_PRINT_TEXT('10mm', '0mm', '48mm', '5mm', data.shop_name);
    LODOP.SET_PRINT_STYLE("Alignment", 2);
    LODOP.SET_PRINT_STYLE("FontSize", 10);
    LODOP.ADD_PRINT_TEXT('20mm', '0mm', '48mm', '5mm', '***日报***');
    LODOP.SET_PRINT_STYLE("Alignment", 0);
    LODOP.SET_PRINT_STYLE("FontSize", 8);
    LODOP.ADD_PRINT_TEXT('30mm', '0.5mm', '48mm', '5mm', '负责人:' + (data.desk_nushop_admin_name || '无'));
    LODOP.ADD_PRINT_TEXT('36mm', '0.5mm', '48mm', '5mm', '日期:' + data.date );
    let iCurLine = 47;
    // console.log('???',typeof data.daily)
    try{
      data.daily = JSON.parse(data.daily)
    }catch(err){
      data.daily = {}
      LODOP.ADD_PRINT_TEXT('36mm', '0.5mm', '48mm', '5mm', err.message );
    }
    for (const key in data.daily) {
      if (Object.hasOwnProperty.call(data.daily, key)) {
        const element = data.daily[key];
        LODOP.ADD_PRINT_LINE(iCurLine + "mm", "0.5mm", iCurLine + "mm", "56mm", 1, 0.1);
        iCurLine = iCurLine + 2;
        for (let i = 0; i < element.length; i++) {
          const ele = element[i];
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '16mm', '5mm', ele.label);
          if (ele.middleVal) {
            LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '16.5mm', '16mm', '5mm', ele.middleVal);
          }
          if (ele.value) {
            LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '32.5mm', '16mm', '5mm', ele.value);
          }
          iCurLine = iCurLine + 5;
        }
      }
    }

    LODOP.SET_PRINT_PAGESIZE(3, 480, '10mm', ''); // 设置纸张大小,方向
    LODOP.PREVIEW();
    LODOP.PRINT();
    resolve();
  })
}

// 前台退菜单（废弃）
export function printReturnDish(data) {
  // console.log('进入了lodop前台退菜单', data);
  return new Promise((resolve, reject) => {
    let LODOP = getLodop();
    LODOP.PRINT_INIT(new Date().getTime()); // 初始化
    LODOP.SET_PRINT_STYLE("Alignment", 2);
    LODOP.SET_PRINT_STYLE("FontSize", 15);
    LODOP.ADD_PRINT_TEXT('10mm', '0mm', '48mm', '5mm', '退菜单');
    LODOP.SET_PRINT_STYLE("Alignment", 0);
    LODOP.SET_PRINT_STYLE("FontSize", 8);
    LODOP.ADD_PRINT_TEXT('17mm', '0.5mm', '48mm', '5mm', '桌号:' + data.desk_num);
    LODOP.ADD_PRINT_TEXT('23mm', '0.5mm', '48mm', '5mm', '日期:' + data.return_time);
    LODOP.ADD_PRINT_TEXT('30mm', '0.5mm', '48mm', '5mm', '订单编号:' + data.orderNum);
  
    LODOP.ADD_PRINT_LINE("36mm", "0.5mm", "36mm", "56mm", 1, 0.1);
  
    LODOP.ADD_PRINT_TEXT('40mm', '0.5mm', '38mm', '5mm', '名称');
    LODOP.ADD_PRINT_TEXT('40mm', '38mm', '10mm', '5mm', '数量');
  
    LODOP.ADD_PRINT_LINE("47mm", "0.5mm", "47mm", "56mm", 1, 0.1);
  
    let iCurLine = 50;//标题行之后的数据从位置80px开始打印
    if (data.returnFoodsList) {
      data.returnFoodsList = JSON.parse(data.returnFoodsList)
      if (data.returnFoodsList.length > 0) {
        LODOP.SET_PRINT_STYLE("FontSize", 12);
        for (let i = 0; i < data.returnFoodsList.length; i++) {
          const element = data.returnFoodsList[i];
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '34mm', '5mm', element.food_name);
          LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '37mm', '20mm', '5mm', element.return_num.toString());
          let h = 5;
          if (element[1].length > 7) {
            h = 10;
          }
          iCurLine = iCurLine + h;
        }
      }
    }
  
    LODOP.SET_PRINT_STYLE("FontSize", 8);
    LODOP.ADD_PRINT_LINE(iCurLine + 'mm', "0.5mm", iCurLine + 'mm', "56mm", 1, 0.1);
    iCurLine = iCurLine + 1;
  
    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '57mm', '5mm', '电话：' + data.phone);
    iCurLine = iCurLine + 5;
    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0.5mm', '57mm', '5mm', '地址：' + data.address);
    iCurLine = iCurLine + data.phone.length > 10 ? 25 : 15;

    LODOP.ADD_PRINT_TEXT(iCurLine + 'mm', '0mm', '48mm', '5mm', '');

    iCurLine = iCurLine + 10;
    LODOP.ADD_PRINT_LINE(iCurLine + 'mm', "0.5mm", iCurLine + 'mm', "48mm", 1, 0.1);
  
    LODOP.SET_PRINT_PAGESIZE(3, 480, '10mm', ''); // 设置纸张大小,方向
    // LODOP.PREVIEW();
    LODOP.PRINT();
    resolve();
  })
}

// 除桌码外统一使用该方法
export function printLodopTemp(data) {
  const printWidth = parseInt(localStorage.qiantaiPrintSize) || 58;
  // console.log('printLodopTemp', JSON.stringify(data), printWidth);
  return new Promise(async (resolve, reject) => {
    const html = await lodopHelper.print(data);
    document.getElementById("printArea").innerHTML = html;
    let LODOP = getLodop();
    LODOP.PRINT_INIT(new Date().getTime()); // 初始化
    LODOP.ADD_PRINT_HTM(0,0,document.getElementById("printArea").offsetWidth,document.getElementById("printArea").offsetHeight,document.getElementById("printArea").innerHTML);
    LODOP.SET_PRINT_PAGESIZE(3, printWidth == 58 ? 580 : 700, 45, ""); // 设置纸张大小,方向
    // LODOP.PREVIEW();
    LODOP.PRINT();
    resolve();
  })
}

// 获取所有设备
export function getAllPrinters() {
  //获取打印机设备数，用于进行遍历
  let arr = []
  let LODOP = getLodop();
  var count = LODOP.GET_PRINTER_COUNT(); //获取打印机个数
  if(count && count > 0 ){
    for (var i = 0; i < count; i++) {
      //根据设备序号获取设备名
      // var msg = LODOP.GET_PRINTER_NAME(i);
      arr.push(LODOP.GET_PRINTER_NAME(i));
      console.log(LODOP.GET_PRINTER_NAME(i), 'PaperWidth', LODOP.GET_PRINTER_NAME(i + ':PaperWidth'));
      console.log(LODOP.GET_PRINTER_NAME(i), 'MaxExtentWidth', LODOP.GET_PRINTER_NAME(i + ':MaxExtentWidth'));
    }
    return arr
  }else{
    // console.log('none printer exists')
    return arr;
  }
}

// 标签制作单
export function labelPrintLodopTemp(data) {
  return new Promise(async (resolve, reject) => {
    const html = await lodopHelper.print(data);
    document.getElementById("printArea").innerHTML = html;
    let LODOP = getLodop();
    LODOP.PRINT_INIT(new Date().getTime()); // 初始化
    LODOP.SET_PRINTER_INDEX(data.printer_name);//指定某虚拟打印机
    if (data.labelSize == 60) {
      LODOP.SET_PRINT_PAGESIZE(0, 600, 400, "A4");
    } else if (data.labelSize == 50) {
      LODOP.SET_PRINT_PAGESIZE(0, 500, 400, "A4");
    } else {
      LODOP.SET_PRINT_PAGESIZE(0, 400, 300, "A4");
    }
    LODOP.ADD_PRINT_HTM(0, 10, document.getElementById("printArea").offsetWidth, document.getElementById("printArea").offsetHeight, document.getElementById("printArea").innerHTML);
    LODOP.SET_PRINT_MODE("PRINT_START_PAGE", 1);
    LODOP.SET_PRINT_MODE("PRINT_END_PAGE", 1);
    // LODOP.PREVIEW();
    LODOP.PRINT();
    resolve();
  })
}


// WEBPACK FOOTER //
// ./src/utils/winPrint.js